(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("underscore"));
	else if(typeof define === 'function' && define.amd)
		define(["underscore"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("underscore")) : factory(root["underscore"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__7__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 154);
/******/ })
/************************************************************************/
/******/ ({

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(155);


/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "defineConstProperty", {
  enumerable: true,
  get: function get() {
    return _properties.defineConstProperty;
  }
});
Object.defineProperty(exports, "defineProducedProperty", {
  enumerable: true,
  get: function get() {
    return _properties.defineProducedProperty;
  }
});
Object.defineProperty(exports, "defineProducedPropertyOnClass", {
  enumerable: true,
  get: function get() {
    return _properties.defineProducedPropertyOnClass;
  }
});
Object.defineProperty(exports, "defineComputedProperty", {
  enumerable: true,
  get: function get() {
    return _properties.defineComputedProperty;
  }
});
Object.defineProperty(exports, "hasOwnProperty", {
  enumerable: true,
  get: function get() {
    return _properties.hasOwnProperty;
  }
});

var _properties = __webpack_require__(156);

/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defineConstProperty = defineConstProperty;
exports.defineProducedProperty = defineProducedProperty;
exports.defineProducedPropertyOnClass = defineProducedPropertyOnClass;
exports.defineComputedProperty = defineComputedProperty;
exports.hasOwnProperty = hasOwnProperty;

var _underscore = _interopRequireDefault(__webpack_require__(7));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * the reflection module for property defintions
 */

/**
 * Define a const property
 * @param {Object} obj - the host object of the proprty
 * @param {String} name - the name of the property
 * @param {Object} value - the value of the property
 * @return {Object} the host object
 */
function defineConstProperty(obj, name, value) {
  return Object.defineProperty(obj, name, {
    value: value,
    enumerable: true,
    writable: false
  });
}
/**
 * Define a produced property with a factory
 * @param {Object} obj - the host object of the proprty
 * @param {String} name - the name of the property
 * @param {Function} factory - the factory to produce the property value
 * @return {Object} the host object
 */


function defineProducedProperty(obj, name, factory) {
  return Object.defineProperty(obj, name, {
    get: function get() {
      var value = factory.apply(obj);
      defineConstProperty(obj, name, value);
      return value;
    },
    enumerable: true,
    configurable: true
  });
}
/**
 * Define a produced property on a class
 * @param {Class} Class - the host class of the proprty
 * @param {String} name - the name of the property
 * @param {Function} factory - the factory to produce the property value
 * @return {Class} the host class
 */


function defineProducedPropertyOnClass(Class, name, factory) {
  // TODO: wewei, use ES6 Symbol to implement this when babel-polyfill is ready
  var RAND_MAX = 65535;

  var className = Class.name || "Anony" + _underscore.default.random(0, RAND_MAX);

  var symbol = "__" + className + "_" + name;
  Object.defineProperty(Class.prototype, name, {
    get: function get() {
      if (!Object.prototype.hasOwnProperty.call(this, symbol)) {
        defineConstProperty(this, symbol, factory.apply(this));
      }

      return this[symbol];
    },
    enumerable: true
  });
  return Class;
}
/**
 * Define a computed property whose value is computed each time the getter being called
 * @param {Object} obj - the host object of the proprty
 * @param {String} name - the name of the property
 * @param {Function} getter - the getter to compute the property value
 * @return {Object} the host object
 */


function defineComputedProperty(obj, name, getter) {
  return Object.defineProperty(obj, name, {
    get: getter,
    enumerable: true
  });
} // Make the functions chainable with underscorejs


_underscore.default.mixin({
  defineConstProperty: defineConstProperty,
  defineProducedProperty: defineProducedProperty,
  defineProducedPropertyOnClass: defineProducedPropertyOnClass,
  defineComputedProperty: defineComputedProperty
});
/**
 * Detect whether or not a object has certain property without evaluation
 * @param {Object} obj - the host class of the proprty
 * @param {String} name - the name of the property
 * @return {Boolean} whether the property is defined
 */


function hasOwnProperty(obj, name) {
  return !!Object.getOwnPropertyDescriptor(obj, name);
}

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__7__;

/***/ })

/******/ });
});
